<div *ngIf="checkIfBannerIsVisible()" class="banner">{{ message | translate }}</div>
